import { render, staticRenderFns } from "./CertifGrad.vue?vue&type=template&id=97e0dfa6&scoped=true&"
import script from "./CertifGrad.vue?vue&type=script&lang=js&"
export * from "./CertifGrad.vue?vue&type=script&lang=js&"
import style0 from "./CertifGrad.vue?vue&type=style&index=0&id=97e0dfa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e0dfa6",
  null
  
)

export default component.exports